/**
 * Returns the input value if it's truthy and matches the accepted value validator,
 * otherwise returns null.
 *
 * @param value - The string value to validate (can be nullish)
 * @param validator - Either a regex pattern or an array of accepted string values
 * @returns The validated string or null
 */

export function getAcceptedValue(
  value: string | null | undefined,
  validator: RegExp | string[]
): string | null {
  if (!value) {
    return null
  }

  if (validator instanceof RegExp) {
    return validator.test(value) ? value : null
  }

  return validator.includes(value) ? value : null
}
